"use strict";
/** ISO-639-1 language codes **/
Object.defineProperty(exports, "__esModule", { value: true });
exports.supportedLanguages = void 0;
exports.supportedLanguages = {
    English: 'en',
    Spanish: 'es',
    French: 'fr',
};
//# sourceMappingURL=supported-languages.js.map